import React from "react";
import { createRoot } from "react-dom/client";
import TitlepageCanvas from "./index";
import "./styles.css";

function App() {
  return <TitlepageCanvas />;
}

const el = document.getElementById("root");
if (!el) {
  const container = document.createElement("div");
  container.id = "root";
  document.body.appendChild(container);
}

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
